// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/**
 * Problems as the editor keeps them. Apart from the YAML-aware
 * `diagnostics`, so the requests that carry problems load no YAML parser.
 */
import { EMonitoringProblemSeverity } from "../editor/types";
var SEVERITIES = {
    error: EMonitoringProblemSeverity.ERROR,
    warning: EMonitoringProblemSeverity.WARNING,
};
/** Problems as they arrive, from WASM (`"error"`) or Harvest (`"ERROR"`), in one shape. */
export var normalizeProblems = function (raw) {
    if (!Array.isArray(raw))
        return [];
    return raw.flatMap(function (entry) {
        var _a;
        if (!entry || typeof entry !== "object")
            return [];
        var record = entry;
        var text = function (value) { return (typeof value === "string" ? value : ""); };
        return [
            {
                severity: (_a = SEVERITIES[text(record.severity).toLowerCase()]) !== null && _a !== void 0 ? _a : EMonitoringProblemSeverity.ERROR,
                code: text(record.code),
                path: text(record.path),
                message: text(record.message),
                engine_code: typeof record.engine_code === "string" ? record.engine_code : undefined,
            },
        ];
    });
};
